import React from "react";
import { Star } from "lucide-react";

const items = [
  {
    quote:
      "I received 3 BRRR deals in my first month. The quality of analysis in each pack is second to none.",
    name: "Sarah M.",
    role: "Full-time Investor",
  },
  {
    quote:
      "Their flip sourcing was first-class — we completed our latest refurb in 14 weeks with a £62k profit margin. The numbers landed exactly as projected.",
    name: "David K.",
    role: "Property Developer",
  },
  {
    quote:
      "Honest, professional, and incredibly knowledgeable. I wouldn't source without them now.",
    name: "Rachel B.",
    role: "BTL Investor",
  },
];

export function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="bg-[var(--ivory)] py-24 lg:py-32"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="reveal text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[var(--gold-deep)]" />
            <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold-deep)]">
              Investor Voices
            </span>
            <span className="h-px w-10 bg-[var(--gold-deep)]" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl text-[var(--navy)] leading-[1.05]">
            Trusted by investors.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="reveal bg-[var(--navy)] text-[var(--ivory)] p-8 lg:p-10 relative"
            >
              <span className="absolute top-0 left-0 w-[2px] h-full bg-[var(--gold)]" />
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="text-[var(--gold)] fill-[var(--gold)]" />
                ))}
              </div>
              <blockquote className="font-display text-[1.25rem] leading-[1.45] italic">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-5 border-t border-[rgba(201,168,76,0.18)] text-[0.78rem] tracking-[0.16em] uppercase text-[var(--ivory)]/70">
                {t.name}
                <span className="text-[var(--gold)] mx-2">·</span>
                <span className="text-[var(--ivory)]/55 normal-case tracking-normal">
                  {t.role}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
